import { CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField, Typography, withStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import DatePicker from '../../../components/Header/SubheaderToolbar/Filters/DatePicker.js';
import React, { Component, Fragment } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { compose } from 'recompose';
import { withMixpanel } from '../../../components/Common/withMixpanel';
import SelectSuperior from './SelectSuperior';

const styles = theme => ({
    datePicker: {
        margin: 0,
        width: '100%'
    },
    button: {
        textTransform: 'none',
        color: theme.customColors.primary.b600,
        backgroundColor: '#ffffff',
        margin: '14px 10px 14px 10px',
        width: 92,
    },
    buttonProgress: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
    errorOccurred: {
        color: 'red'
    },
    userExistAlert: {
        fontSize: 'inherit',
        fontWeight: 'bold',
        maxWidth: 600
    }
})

export class InviteUser extends Component {
    state = {
        openSuperior: false,
        error: {},
        email: '',
        firstname: "",
        lastname: "",
        userName: "",
        birthday: new Date(1970, 1, 1),
    }

    fixInvalidUserName = (userName) => {
        return (userName || '').replace(/\t|\s|\n/gm, '').toLowerCase()
    }

    onFirsNameChange = (event) => {
        const newName = event.target.value
        const newValue = this.onChange("firstname", newName)

        this.updateUserNameError(newValue + this.state.lastname)
    }

    onTitleChange = (event) => {
        const title = event.target.value
        // const newValue = this.onChange("title", newName)
        this.setState({ title: title })

        // this.updateUserNameError(newValue + this.state.lastname)
    }

    onLastNameChange = (event) => {
        const newName = event.target.value
        const newValue = this.onChange("lastname", newName)

        this.updateUserNameError(this.state.firstname + newValue)
    }

    onUserNameChange = (event) => {
        const newName = this.fixInvalidUserName(event.target.value);
        const newValue = this.onChange("userName", newName)

        this.updateUserNameError(newValue)
    }


    getUserName = () => {
        const { firstname, lastname, userName } = this.state;

        return userName || this.fixInvalidUserName(`${firstname}${lastname}`)
    }

    handleChangeMail = (e) => {
        const email = e.target.value
        const regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        this.setState({
            error: {
                ...this.state.error,
                email: !regex.test(email)
            },
            email
        })
    }

    removeInvalidName = (name) => {
        return name.replace(/^[^\x00-\x7F]+[^a-z]+[^a-z0-9]*/gi, "")
    }

    updateUserNameError = (userName) => {

        const isExist = this.isUserNameExist(userName)

        this.setState({
            error: {
                ...this.state.error,
                userName: isExist
            }
        })
    }

    onChange = (name, newName) => {
        const newValue = this.removeInvalidName(newName);

        const fieldError = newName !== newValue ? "The field can only contain English letters" : ""

        this.setState({
            [name]: newValue,
            error: {
                ...this.state.error,
                [name]: fieldError
            }
        });

        return newValue;
    }

    invite = () => {
        const { email, firstname, lastname, userName, title, superiorId, birthday } = this.state
        const { mixpanelTrack } = this.props

        this.setState({ saving: true })

        const newUser = {
            firstname,
            lastname,
            email,
            title,
            tag: this.getUserName(),
            superiorId,
            birthday
        }

        this.props.userSettingsService.adminInviteUser(newUser)
            .then(res => {
                if (res.status && res.status >= 400) {
                    this.errorInServer()
                    mixpanelTrack('Error inviting user', {})
                } else {
                    this.clearDialog({ open: false })
                    mixpanelTrack('Invited user')

                }
            }, rej => {
                this.errorInServer()
            }).catch(e => {
                this.errorInServer()
            })
    }

    errorInServer = () => {
        this.setState({ saving: false, isErrorOccurred: true })
    }

    clearDialog = (params = {}) => {
        this.setState({
            error: {},
            email: '',
            saving: false,
            isErrorOccurred: false,
            ...params
        });
    }

    openDialog = () => {
        this.clearDialog({ open: true })
    };

    closeDialog = () => {
        this.clearDialog({ open: false })
    };

    isUserNameExist = (userName) => {
        const fixedUsername = this.fixInvalidUserName(userName)

        if (!fixedUsername) {
            return false
        }

        return this.props.users.some(user => user.tag === fixedUsername)
    }

    renderFields = () => {
        const { classes, t } = this.props;
        const { firstname, lastname, email, title, error } = this.state;

        const userName = this.getUserName();
        const userNameDisabled = !(firstname && lastname) || !this.isUserNameExist(firstname + lastname)
        const selectUser = (superiorId) => {
            const superior = this.props.users.find(u => u.id === superiorId)
            const superiorTag = superior ? '@' + superior.tag : null
            this.setState({ superiorId, superiorTag })
        }
        const getSuperiorTag = () => {
            const { users,t } = this.props;
            const { superiorId } = this.state;

            let tag = t('Unassigned')
            if (superiorId != null) {
                const superior = users.find(u => u.id == superiorId)
                if (superior) {
                    tag = `@${superior.tag}`
                }
            }

            return tag
        }
        return <div data-intrcm-id="InviteUser_o5uooxf2">
            <TextField
                autoFocus
                margin="dense"
                value={firstname}
                label={t('First name')}
                fullWidth
                onChange={this.onFirsNameChange}
                className={classes.textField}
                error={error.firstname}
                helperText={error.firstname}
            />
            <TextField
                margin="dense"
                value={lastname}
                label={t("Last name")}
                fullWidth
                onChange={this.onLastNameChange}
                className={classes.textField}
                error={error.lastname}
                helperText={error.lastname}
            />
            <TextField
                autoFocus
                margin="dense"
                value={'@' + userName}
                label={t('User Name')}
                fullWidth
                onChange={this.onUserNameChange}
                error={error.userName}
                helperText={error.userName ? 'This user name already exist in the organization' : ''}
                disabled={userNameDisabled}
                className={classes.textField}
            />
            <TextField
                margin="dense"
                error={this.state.error.email}
                value={email}
                id="email"
                label={t("Email")}
                type="email"
                fullWidth
                onChange={this.handleChangeMail}
            />
            <TextField
                margin="dense"
                value={title}
                label={t('Job title')}
                fullWidth
                onChange={this.onTitleChange}
                className={classes.textField}
            />

            <DatePicker
                classes={{ datePicker: classes.datePicker }}
                selectedDate={this.state.birthday}
                onChange={(date) => this.setState({ "birthday": date })}
                label={t('Birthday')} />
            <div data-intrcm-id="InviteUser_edfcc3ny" onClick={() => { this.setState({ openSuperior: true }) }} >
                <TextField
                    fullWidth
                    value={getSuperiorTag()}
                    label={t("Superior")} />
            </div>
            {/* <SelectSuperior userId={this.state.userId} open={this.state.openSuperior} handleClose={this.toggleSuperior} selectUser={this.selectUser} superiorId={this.state.superiorId} /> */}
            <SelectSuperior userId={-1} open={this.state.openSuperior} handleClose={() => { this.setState({ openSuperior: false }) }} selectUser={selectUser}
                superiorId={this.state.superiorId} />

        </div>
    }

    render() {
        const { classes,t } = this.props;
        const { firstname, lastname, email, error } = this.state;
        const isSaveButtonDisabled = error.userName || !(firstname && lastname && email)

        return <Fragment>
            <Button style={{ margin: '0 16px 15px auto' }} onClick={this.openDialog} variant="contained" color="secondary">
                {t('Invite user')}
            </Button>

            <Dialog
                open={this.state.open}
                onClose={this.closeDialog}
                aria-labelledby="form-dialog-title">

                {this.state.isErrorOccurred
                    ? <DialogTitle>
                        <Typography gutterBottom color='secondary' className={classes.userExistAlert}>
                            {t('The email you have entered is already in use or invalid. Please try again or contact Tuqqi support')}
                                                    </Typography>
                    </DialogTitle>
                    : null
                }

                <DialogContent style={{ maxWidth: 600 }}>
                    <DialogContentText>
                        {t('Invite new user')}
                    </DialogContentText>
                    <br />

                    {this.renderFields()}
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.clearDialog} aria-label="delete" className={classes.button}>{t('Clear')}</Button>
                    <div data-intrcm-id="InviteUser_ju341uba" style={{ position: 'relative' }}>
                        <Button onClick={this.invite} aria-label="save" className={classes.button}
                            disabled={isSaveButtonDisabled} variant="contained" size="small">
                            {t('Invite')}
                        </Button>
                        {this.state.saving ? <CircularProgress size={25} className={classes.buttonProgress} color="secondary" /> : null}
                    </div>
                </DialogActions>
            </Dialog>
        </Fragment>
    }

}

const mapStateToProps = (state) => ({
    ...state.services,
    globalData: state.globalData,
    users: state.globalData.users,
    userData: state.userData,
    classifications: state.globalData.classifications,
    user: state.customMappings.currentUser
})

const mapDispatchToProps = dispatch => {
    return {
        goTo: path => { dispatch(push(path)) },
        dispatch: dispatch
    }
}

export default compose(
    withStyles(styles, { withTheme: true }),
    withMixpanel,
    withTranslation('userEditModal'),
    connect(
        mapStateToProps,
        mapDispatchToProps
    ))(InviteUser);